// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import SignUpAdmin from "layouts/authentication/sign-up-admin";
import ProtectedRouteAdmin from "layouts/authentication/components/protect/ProtectedRouteAdmin";
import ProtectedRouteSuperAdmin from "layouts/authentication/components/protect/ProtectedRouteSuperadmin";
import Produk from "layouts/Produk/index";
import Account from "layouts/account/index";
import EcommerceDashboard from "layouts/ecommerce/index";
import EcommerceCheckout from "layouts/ecommerce/CheckoutPage";
import EcommerceHistory from "layouts/ecommerce/RiwayatPesanan";
import DaftarPelanggan from "layouts/daftar-pelanggan";
// @mui icons
import Icon from "@mui/material/Icon";
import RedirectIfAuthenticated from "layouts/authentication/components/protect/RedirectIfAuthenticated";
import { Check } from "@mui/icons-material";

const token = sessionStorage.getItem("token");
const user = sessionStorage.getItem("role");
const role = user?.role;

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: (
      <ProtectedRouteAdmin>
        <Dashboard />
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: "collapse",
    name: "Transaksi",
    key: "transaksi",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/transaksi",
    component: (
      <ProtectedRouteAdmin>
        <Tables />
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: "collapse",
    name: "Produk",
    key: "produk",
    icon: <Icon fontSize="small">shopping_basket</Icon>,
    route: "/produk",
    component: (
      <ProtectedRouteAdmin>
        <Produk />
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: "collapse",
    name: "Daftarkan Restoran",
    key: "sign-up-admin",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-up-admin",
    component: <SignUpAdmin />,
  },
  {
    type: "collapse",
    name: "Daftar pelanggan",
    key: "daftar-pelanggan",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/daftar-pelanggan",
    component: <DaftarPelanggan />,
  },
  ...(role === "SUPERADMIN"
    ? [
        {
          type: "collapse",
          name: "Users",
          key: "user",
          icon: <Icon fontSize="small">people</Icon>,
          route: "/user",
          component: (
            <ProtectedRouteSuperAdmin>
              <Account />
            </ProtectedRouteSuperAdmin>
          ),
        },
      ]
    : []),
  {
    type: "hidden",
    name: "Transaksi",
    key: "billing",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/billing",
    component: (
      <ProtectedRouteAdmin>
        <Billing />
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: "hidden",
    name: "Notifications",
    key: "notifications",
    icon: <Icon fontSize="small">notifications</Icon>,
    route: "/notifications",
    component: <Notifications />,
  },
  {
    type: "hidden",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: (
      <ProtectedRouteAdmin>
        <Profile />
      </ProtectedRouteAdmin>
    ),
  },
  {
    type: "hidden",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: (
      <RedirectIfAuthenticated>
        <SignIn />
      </RedirectIfAuthenticated>
    ),
  },
  {
    type: "hidden",
    name: "Sign-up",
    key: "sign-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-up",
    component: <SignUp />,
  },
  {
    type: "hidden",
    name: "Ecommerce",
    key: "ecommerce-dashboard",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/ecommerce/dashboard",
    component: <EcommerceDashboard />,
  },
  {
    type: "hidden",
    name: "Checkout",
    key: "ecommerce-checkout",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/ecommerce/checkout",
    component: <EcommerceCheckout />,
  },

  {
    type: "hidden",
    name: "Checkout",
    key: "ecommerce-history",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/ecommerce/history",
    component: <EcommerceHistory />,
  },
];

export default routes;
